// Мессенджеры (README §7): CLI-вид канала — тот же каркас, что у Бесед
// (panes/cli/CliSession, вариант «channel»: без `!`-режима, ui-plan п.8).
// Меню: «каналы» — Телеграм «подключён», WhatsApp/Почта/Slack «нет» —
// и «+ канал» (беседа «новый раздел», README §10.1).
//
// Канал — закреплённая сессия роли telegram: её не создают руками, сервер
// поднимает её сам, и только ей достаётся telegram-MCP (AGENTBOX_EXCLUSIVE_MCP).

import CliSession from '../../panes/cli/CliSession'
import ErrorBoundary from '../../shell/ErrorBoundary'
import { useAppStore } from '../../store/appStore'
import { SideMenu } from '../../ui/SideMenu'
import type { SectionModule } from '../types'
import '../../panes/cli/cli.css'

const CHANNELS = 4

function Sidebar() {
  const tg = useAppStore((s) => s.sessions.find((x) => x.role === 'telegram') ?? null)
  const section = useAppStore((s) => s.section)
  const openTelegram = useAppStore((s) => s.openTelegram)
  const denied = useAppStore((s) => s.telegramDenied)
  const setNotice = useAppStore((s) => s.setNotice)
  const addChannel = () => void useAppStore.getState().newSectionDraft()
  const soon = () => setNotice('Этот канал ещё не подключён — «+ канал» опишет его в беседе.')
  const live = tg !== null && tg.state !== 'exited'
  return (
    <SideMenu
      screen="messengers"
      sections={[{
        id: 'messengers',
        title: 'Мессенджеры',
        count: `${tg ? 1 : 0} из ${CHANNELS}`,
        onAdd: addChannel,
        addTitle: 'новый канал',
        items: [{
          id: 'channels',
          label: 'каналы',
          children: [
            {
              id: 'telegram',
              label: 'Телеграм',
              live,
              active: section === 'messengers',
              title: !tg && denied ? denied : undefined,
              meta: tg ? (live ? 'подключён' : 'остановлен') : 'нет',
              metaTone: tg ? (live ? 'ok' : 'warn') : 'dim',
              onSelect: () => void openTelegram(),
            },
            { id: 'whatsapp', label: 'WhatsApp', meta: 'нет', onSelect: soon },
            { id: 'mail', label: 'Почта', meta: 'нет', onSelect: soon },
            { id: 'slack', label: 'Slack', meta: 'нет', onSelect: soon },
            { id: 'add', label: '+ канал', action: true, onSelect: addChannel },
          ],
        }],
      }]}
    />
  )
}

function View() {
  const channel = useAppStore((s) => s.sessions.find((x) => x.role === 'telegram') ?? null)
  const creating = useAppStore((s) => s.creating)
  const openTelegram = useAppStore((s) => s.openTelegram)
  const denied = useAppStore((s) => s.telegramDenied)
  if (!channel && denied) {
    return (
      <div className="cli-empty">
        <span>⏺ {denied}.</span>
      </div>
    )
  }
  if (!channel) {
    return (
      <div className="cli-empty">
        <span>⏺ Телеграм ещё не поднят. Канал держит аккаунт в одиночку — второй процесс
          к тому же аккаунту подключиться не сможет.</span>
        <button type="button" disabled={creating} onClick={() => void openTelegram()}>
          {creating ? 'поднимаю…' : 'открыть Телеграм'}
        </button>
      </div>
    )
  }
  return (
    <ErrorBoundary key={channel.id} scope="канал Телеграм" compact>
      <CliSession sessionId={channel.id} variant="channel" placeholder="сообщение агенту…" />
    </ErrorBoundary>
  )
}

function useRail() {
  const tg = useAppStore((s) => s.sessions.some((x) => x.role === 'telegram'))
  return { count: `${tg ? 1 : 0}/${CHANNELS}`, tip: `каналы: ${tg ? 1 : 0} подключён из ${CHANNELS}` }
}

const messengers: SectionModule = { Sidebar, View, keepAlive: true, useRail }
export default messengers
